<template>
  <div>
    <v-footer
      v-if="showFooter && config"
      fixed
      padless
      class="elevation-0"
      style="z-index: 100;"
    >
      <v-card
        width="100%"
        tile
        flat
        :color="config.extemporaneo ? '#D32F2F' : '#F7A800'"
        :class="config.extemporaneo ? 'white--text' : 'grey--text text--darken-4'"
        height="32"
        class="d-flex align-center shadow-top"
      >
        <v-row no-gutters align="center" class="px-2 barra-estado-single">
          
          <v-col :cols="config.extemporaneo ? 3 : 4" class="px-2 d-flex align-center border-right">
            <span class="label-inline mr-1 flex-shrink-0" style="white-space: nowrap;">
              Unidad Médica:
            </span>

            <div class="d-flex align-center" style="overflow: hidden; width: 100%;">
              <div v-if="ids_unidades_medicas.length <= 1" class="text-truncate font-weight-bold">
                {{ unidadMedicaMostrar() }}
              </div>
              
              <v-autocomplete
                v-else
                v-model="id_unidad_medica_actual"
                :items="unidadesMedicasFiltradas()"
                item-value="id_unidad_medica"
                :item-text="codigoNombre"
                @change="cambiarUnidadMedica"
                dense 
                hide-details 
                flat 
                solo
                background-color="rgba(255,255,255,0.3)"
                class="minimal-select-single"
              ></v-autocomplete>
            </div>
          </v-col>

          <v-col :cols="config.extemporaneo ? 3 : 4" class="px-3 d-flex align-center border-right">
            <span class="label-inline mr-1">Programa:</span>
            <div class="text-truncate" v-if="config.codigo_programa">
              <span class="font-weight-black">[{{ config.codigo_programa }}]</span>
              <span class="ml-1 opacity-8">{{ config.nombre_programa }}</span>
            </div>
            <span v-else class="opacity-5 italic">No Asignado</span>
          </v-col>

          <v-col :cols="config.extemporaneo ? 3 : 4" class="px-3 d-flex align-center" :class="{'border-right': config.extemporaneo}">
            <span class="label-inline mr-1">Proyecto:</span>
            <div class="text-truncate" v-if="config.codigo_proyecto">
              <span class="font-weight-black">[{{ config.codigo_proyecto }}]</span>
              <span class="ml-1 opacity-8">{{ config.nombre_proyecto }}</span>
            </div>
            <span v-else class="opacity-5 italic">No Asignado</span>
          </v-col>

          <v-col v-if="config.extemporaneo" cols="3" class="px-2 d-flex align-center justify-center">
            <div class="extemporaneo-flat-single">
              <v-icon x-small left color="white">mdi-clock-alert</v-icon>
              {{ config.extemporaneo_fecha }}
            </div>
          </v-col>

        </v-row>
      </v-card>
    </v-footer>

    <div :style="{ paddingBottom: showFooter ? '32px' : '0' }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// El script se mantiene igual al anterior para asegurar funcionalidad
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  props: { ignoreConfig: { type: Boolean, default: false } },
  data: () => ({
    ids_vistas_footer: [1, 2, 3, 9, 10, 11, 12, 13],
    config: { extemporaneo: false, codigo_programa: null, codigo_proyecto: null, extemporaneo_fecha: null },
    unidades_medicas: [],
    id_unidad_medica_actual: null
  }),
  computed: {
    ...mapState(['ids_vistas', 'id_unidad_medica_activa', 'ids_unidades_medicas']),
    showFooter() {
      if (!this.ids_vistas || !Array.isArray(this.ids_vistas)) return false;
      return this.ids_vistas.some(id => this.ids_vistas_footer.includes(id));
    }
  },
  mounted() {
    if (this.showFooter) this.getUnidadesMedicas();
    this.obtenerConfiguracionActual();
  },
  methods: {
    codigoNombre: i => `[${i.codigo}] ${i.nombre}`,
    obtenerConfiguracionActual() {
      axios.get('/Configuraciones/MostrarConfiguracion').then(res => { this.config = res.data; });
    },
    getUnidadesMedicas() {
      axios.get('/Catalogos/ListarUnidadesMedicas?ignore_config=true').then(res => {
        this.unidades_medicas = res.data;
        this.id_unidad_medica_actual = this.id_unidad_medica_activa;
      });
    },
    unidadesMedicasFiltradas() {
      return this.unidades_medicas.filter(x => this.ids_unidades_medicas?.includes(x.id_unidad_medica));
    },
    unidadMedicaMostrar() {
      const u = this.unidades_medicas.find(x => x.id_unidad_medica == this.id_unidad_medica_activa);
      return u ? u.nombre : 'No asignado';
    },
    cambiarUnidadMedica() {
      axios.put(`/Users/CambiarUnidadMedica/${this.id_unidad_medica_actual}?ignore_config=true`)
        .then(() => { this.$store.dispatch('refreshtoken').then(() => this.$router.go()); });
    }
  }
}
</script>

<style scoped>
/* Altura ultra compacta */
.barra-estado-single {
  font-size: 0.7rem !important;
  width: 100%;
}

.label-inline {
  font-weight: 800;
  font-size: 0.6rem;
  opacity: 0.6;
}

/* Divisores verticales sutiles */
.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  height: 18px; /* Línea divisoria corta para verse más moderno */
}

/* Ajuste del Autocomplete para altura de 32px */
.minimal-select-single {
  font-size: 0.7rem !important;
  width: 100%;
}
::v-deep .minimal-select-single .v-input__control {
  min-height: 22px !important;
}
::v-deep .minimal-select-single .v-input__slot {
  padding: 0 4px !important;
  border-radius: 2px !important;
}

/* Badge para el modo extemporáneo */
.extemporaneo-flat-single {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 1px 8px;
  border-radius: 2px;
  font-size: 0.65rem;
  font-weight: bold;
  white-space: nowrap;
}

.shadow-top {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.opacity-8 { opacity: 0.85; }
.opacity-5 { opacity: 0.5; }
.italic { font-style: italic; }
</style>